import styled from 'styled-components';

export const AssetReviewsContainer = styled.section`
  width: 100vw;
  height: 100%;
  background: #191819;
  clip-path: polygon(0 10%, 100% 0%, 100% 91%, 0% 100%);
  margin-bottom: 5rem;
  overflow: hidden;
  position: relative;
  padding: 8rem 1rem;
  .blueColor {
    position: absolute;
    right: 0;
    top: 0;
    box-shadow: 10px 20px 200px 150px ${(props) => props.theme.primary};
  }
  .redColor {
    position: absolute;
    left: 0;
    bottom: 0;
    box-shadow: 50px 0px 200px 150px red;
  }
  img {
    margin-left: auto;
  }

  @media (max-width: 768px) {
    img {
      margin-left: 0;
    }
  }
`;

export const AssetReviewsContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  max-width: 66.25rem;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  gap: 1rem;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 480px) {
    .previewImg {
      width: 100%;
      max-width: 22rem;
    }
  }
`;

export const AssetReviewsCol = styled.div`
  display: flex;
  flex-direction: column;
  color: ${(props) => props.theme.white};
  position: relative;
  z-index: 1;

  header {
    display: flex;
    flex-direction: column;
    span {
      font-weight: 400;
      font-size: 0.75rem;
      line-height: 200%;
    }
    h2 {
      font-weight: 500;
      font-size: 1.75rem;
      line-height: 150%;
      color: ${(props) => props.theme.white};
    }
  }
  p {
    margin: 3rem 0;
    font-weight: 400;
    font-size: 1.125rem;
    color: #e4e4e4;
  }
  button {
    all: unset;
    background: ${(props) => props.theme.primary};
    padding: 1.25rem;
    text-align: center;
    width: 100%;
    max-width: 13.125rem;
    border-radius: 8px;
    color: ${(props) => props.theme.white};
    font-weight: 500;
    font-size: 1.125rem;
  }

  @media (max-width: 768px) {
    header {
      margin-top: 3rem;
      span {
        font-size: 0.625rem;
        font-weight: 400;
        line-height: 240%;
      }
      h2 {
        font-weight: 500;
        font-size: 1.125rem;
      }
    }
    p {
      font-size: 0.875rem;
      margin: 2.25rem 0;
    }
  }
`;
